import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-95cb3ef4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-creation-wizard ff-bottom-fixed-cta" }
const _hoisted_2 = { class: "profile-creation-wizard__container" }
const _hoisted_3 = { class: "profile-creation-wizard__content-actions" }
const _hoisted_4 = { class: "profile-creation-wizard__content" }
const _hoisted_5 = { class: "bloc" }
const _hoisted_6 = { class: "custom-font-text" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "profile-creation-wizard__content__avatar"
}
const _hoisted_9 = { class: "bloc" }
const _hoisted_10 = { class: "profile-creation-wizard__content-footer" }

import {RegisteredDependencies} from '@/profile-creation-wizard/common/DependencyInjection';
    import {eventBusProfileCreationWizard} from '@/profile-creation-wizard/common/events';
    import {StepNavigator} from '@/profile-creation-wizard/common/step/StepNavigator';
    import StepActions from '@/profile-creation-wizard/common/ui/step/StepActions.vue';
    import StepMobileHeader from '@/profile-creation-wizard/common/ui/step/StepMobileHeader.vue';
    import StepItemTitle from '@/profile-creation-wizard/common/ui/StepItemTitle.vue';
    import AccountUploadPhotoDialog from '@/profile-creation-wizard/components/for-completion/ui/5_description/AccountUploadPhotoDialog.vue';
    import DescriptionSide from '@/profile-creation-wizard/components/for-completion/ui/5_description/DescriptionSide.vue';
    import {ProfileCreationFunnelMode} from '@/profile-creation-wizard/config/steps/ProfileCreationSteps';
    import {Photo} from '@malt/asset-utils';
    import {useGlobalProperties, useTranslation} from '@malt/vue3-use';
    import {computed, inject, onBeforeMount, onBeforeUnmount, onMounted, reactive, ref} from 'vue';
    import {useRouter} from 'vue-router';
    import Description from './Description.vue';

    type Form = {
        description: string;
    };

    const stepName = 'description';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'DescriptionStep',
  setup(__props) {

    const defaultForm: Form = {
        description: '',
    };

    const context = useGlobalProperties();
    const {msg} = useTranslation();
    const router = useRouter();

    const profileCompletionRepository = inject(RegisteredDependencies.injectionKeys.profileCompletionRepository);
    const trackingRepository = inject(RegisteredDependencies.injectionKeys.trackingRepository);

    const data = reactive<Form>(defaultForm);

    const accountUploadPhotoDialog = ref<AccountUploadPhotoDialog>();
    const isVisiblePrevisouButton = ref(false);
    const isLoadingButtonNext = ref(false);
    const isLoadingDescription = ref(true);
    const photo = ref<Photo>(null);
    const progressPercentage = ref(0);
    const stepNavigator = ref<StepNavigator>();

    const hasPhoto = computed(() => photo.value !== null);
    const isDescriptionValid = computed(() => data.description.trim().length >= 200);
    const photoUrl = computed(() => {
        if (photo.value) {
            return new Photo(photo.value).getScaledUrl({width: 200});
        }
        return '';
    });

    const isFeatureProfileSignupFecthExistingDataActivated = context.$features.profileSignupFecthExistingData === true;
    onBeforeMount(async () => {
        if (isFeatureProfileSignupFecthExistingDataActivated === true) {
            await Promise.all([fetchDescription(), fetchPhoto()]);
        }

        isLoadingDescription.value = false;
    });

    onMounted(async () => {
        await sendTrackingEvent();
        eventBusProfileCreationWizard.on('wizard:profile-photo-updated', switchPhotoUpload);

        const currentRoute = router.currentRoute;
        const meta = currentRoute.value.meta;

        if (meta.progressPercentage) {
            progressPercentage.value = meta.progressPercentage;
        }

        progressPercentage.value = meta.progressPercentage || 0;
        stepNavigator.value = new StepNavigator(router, undefined, meta.nextStep);
        isVisiblePrevisouButton.value = meta.funnelMode === ProfileCreationFunnelMode.STRATEGY;
    });

    onBeforeUnmount(() => {
        eventBusProfileCreationWizard.off('wizard:profile-photo-updated', switchPhotoUpload);
    });

    async function fetchDescription(): Promise<void> {
        const fetchedDescription = await profileCompletionRepository!.fetchDescription();
        data.description = fetchedDescription.content;
    }

    async function fetchPhoto(): Promise<void> {
        const fetchedPhoto = await profileCompletionRepository!.fetchPhoto(context.$pageContext.profileId);
        if (fetchedPhoto) {
            hasPhoto.value = true;
            photo.value = fetchedPhoto;
        }
    }

    async function sendTrackingEvent(): Promise<void> {
        await trackingRepository!.track('description-view-page-v2');
    }

    function switchPhotoUpload(receivedPhoto: any): void {
        photo.value = receivedPhoto.image;
    }

    async function openPhotoDialog(): Promise<void> {
        await accountUploadPhotoDialog.value.open();
    }

    async function goNext(): Promise<void> {
        isLoadingButtonNext.value = true;
        if (isDescriptionValid.value) {
            await trackingRepository!.track('description-length-v2', {
                descriptionLength: data.description.length,
            });

            await profileCompletionRepository!.updateDescription(data.description);
        }

        stepNavigator.value.next();
        isLoadingButtonNext.value = false;
    }

return (_ctx: any,_cache: any) => {
  const _component_joy_progress_bar = _resolveComponent("joy-progress-bar")!
  const _component_joy_placeholder_button = _resolveComponent("joy-placeholder-button")!
  const _component_joy_avatar = _resolveComponent("joy-avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_joy_progress_bar, { percentage: progressPercentage.value }, null, 8, ["percentage"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(StepMobileHeader, {
            "step-name": stepName,
            "show-button-previous": false
          }),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(StepItemTitle, { "is-optional": true }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(msg)('profile.creation.completion.wizard.v2.photo.title')), 1)
              ]),
              _: 1
            }),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.v2.photo.subtitle')), 1),
            (!hasPhoto.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_joy_placeholder_button, { onJoyPlaceholderButtonClick: openPhotoDialog })
                ]))
              : _createCommentVNode("", true),
            (hasPhoto.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_joy_avatar, {
                    size: "large",
                    "photo-url": photoUrl.value,
                    onClick: openPhotoDialog
                  }, null, 8, ["photo-url"]),
                  _createVNode(_component_joy_placeholder_button, {
                    class: "picture-modify",
                    onJoyPlaceholderButtonClick: openPhotoDialog
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_9, [
            (!isLoadingDescription.value)
              ? (_openBlock(), _createBlock(Description, {
                  key: 0,
                  modelValue: data.description,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((data.description) = $event))
                }, null, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_joy_progress_bar, {
            percentage: progressPercentage.value,
            mode: "mobile"
          }, null, 8, ["percentage"]),
          _createVNode(StepActions, {
            "step-name": stepName,
            "show-button-previous": false,
            "show-button-skip": true,
            "is-disabled-button-next": !isDescriptionValid.value,
            "is-loading-button-next": isLoadingButtonNext.value,
            "is-hidden-button-skip": isDescriptionValid.value,
            "onClick:next": goNext,
            "onClick:skip": goNext
          }, null, 8, ["is-disabled-button-next", "is-loading-button-next", "is-hidden-button-skip"])
        ])
      ]),
      _createVNode(DescriptionSide)
    ]),
    _createVNode(AccountUploadPhotoDialog, {
      ref_key: "accountUploadPhotoDialog",
      ref: accountUploadPhotoDialog
    }, null, 512)
  ]))
}
}

})